<template>
    <div class="animated fadeIn">
        <Request
                ref="request"
                method="POST"
                root="/event-booking-panel/multi-book"
                :onRequestSuccess="requestSuccess"
                :onRequestError="requestError">
            <slot slot="body">
                <BookingSummary ref="bookingSummary" v-model="dataBookingSummary"></BookingSummary>
            </slot>
        </Request>
        <b-button @click="onSaveClick" class="mr-2 pull-right" type="submit" variant="success">
            {{Core.Definition.getDefinition('Enregistrer')}}
        </b-button>
    </div>
</template>

<script>
    import Request from '../../components/Request'
    import BookingSummary from '../../components/BookingSummary'
    export default {
        name: 'EventMultiBookingPanel',
        components: {
            Request,
            BookingSummary
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataBookingSummary: []
            }
        },
        methods: {
            onSaveClick() {
                if (Core.Validation.isValid(this.dataBookingSummary, Core.Value.typeBookingSummary)) {
                    this.$refs.request.clearArgs()
                    this.$refs.request.addArg('bookingSummary', Core.Value.decode(this.dataBookingSummary, Core.Value.typeBookingSummary))
                    this.$refs.request.request()
                } else {
                    this.$refs.request.dataAlert = {
                        variant: 'danger',
                        message: Core.Definition.getDefinition('Vous devez spécifier un utilisateur pour chaque réservations.'),
                        show: true
                    }
                }
            },
            requestSuccess(data) {
                this.dataBookingSummary = []
            },
            requestError() {

            }
        }
    }
</script>
